import { render, staticRenderFns } from "./RecordStudy.vue?vue&type=template&id=7b47a52a&scoped=true"
import script from "./RecordStudy.vue?vue&type=script&lang=js"
export * from "./RecordStudy.vue?vue&type=script&lang=js"
import style0 from "./RecordStudy.vue?vue&type=style&index=0&id=7b47a52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b47a52a",
  null
  
)

export default component.exports